<div class="icon {{ Size }} {{ background_color }}" (click)="onClick()">
  @if (Type === 'icon') {
    <span class="icon-list">
      <app-ce-icon [name]="IconType" [svg_class]="['d-flex']"></app-ce-icon>
    </span>
  }
</div>
